'use client';

import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

import { useCheckbox } from './Provider';

export type LabelProps = ComponentProps<'label'>;

export function Label({ className, ...props }: LabelProps) {
  const { id } = useCheckbox();

  return (
    <label htmlFor={id} className={twMerge('text-sm', className)} {...props} />
  );
}
